import { render } from "./LogoIcon.vue?vue&type=template&id=0e670b48&scoped=true"
const script = {}

import "./LogoIcon.vue?vue&type=style&index=0&id=0e670b48&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e670b48"]])

export default __exports__